import React, { useEffect, useState } from 'react';
import { Card, Input, Button, Space, Row, Col, message } from 'antd';
import axios from 'axios';
import { useConfigQuery } from '../../../../queries/useConfig';

/**
 * props esperadas:
 *  - categoria: { id, nome, idRestaurante, metafields: string JSON ou "" }
 */
const Metafields = ({ elemento = {}, tipo, canal, setElemento , metafields, setMetafields}) => {

    const [saving, setSaving] = useState(false);
    const { data: config } = useConfigQuery();
    const accessToken = window.localStorage.getItem("accessToken");



    const addMetafield = () => {
        setMetafields((prev) => [
            ...prev,
            {
                id: `${Date.now()}-${prev.length}`,
                key: '',
                value: '',
            },
        ]);
    };

    const updateMetafield = (id, field, newValue) => {
        setMetafields((prev) =>
            prev.map((mf) =>
                mf.id === id ? { ...mf, [field]: newValue } : mf
            )
        );
    };

    const removeMetafield = (id) => {
        setMetafields((prev) => prev.filter((mf) => mf.id !== id));
    };

    const handleSave = async () => {

        // Só pega linhas com alguma coisa digitada
        const dataToSave = metafields
            .filter((mf) => mf.key?.trim() !== '' || mf.value?.trim() !== '')
            .map(({ key, value }) => ({ key, value }));

        // Se tiver itens, manda JSON; se não, manda string vazia
        const metafieldsString =
            dataToSave.length > 0 ? JSON.stringify(dataToSave) : '';

            console.log(canal);
        const bodyCategoria = {
            idLoja: config.idLoja,
            metafields: metafieldsString,
            idRefProdCat: elemento.id,
            tipo: tipo,
            canal: canal
        };

        try {
            setSaving(true);

            const accessToken = window.localStorage.getItem('accessToken');

            const options = {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + accessToken,
                },
            };

            const resp = await axios.post(
                `${api.techspdv}/v1/${config.idLoja}/metafields-mkt`,
                bodyCategoria,
                options
            );

            console.log('Resposta do PUT categorias:', resp.data);
            message.success('MetaFields salvos com sucesso!');





            /*
                        let elementoAux = elemento;
                        elementoAux.categoria.metafields = parsed;
                        setElemento(elementoAux);
            
            */











        } catch (err) {
            console.error(err);
            message.error(err.response.data.detail || 'Erro ao salvar MetaFields');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div style={{ padding: 24 }}>
            <Card
                title={`Metafields`}
                extra={
                    <Button type="primary" onClick={handleSave} loading={saving} style={{ color: 'white', backgroundColor: 'black' }}>
                        Salvar
                    </Button>
                }
            >
                <Space direction="vertical" style={{ width: '100%' }} size="middle">
                    {metafields.map((mf) => (
                        <Card
                            key={mf.id}
                            size="small"
                            bodyStyle={{ padding: 12 }}
                        >
                            <Row gutter={8}>
                                <Col xs={24} md={10}>
                                    <Input
                                        placeholder="Chave (ex.: cor)"
                                        value={mf.key}
                                        onChange={(e) =>
                                            updateMetafield(mf.id, 'key', e.target.value)
                                        }
                                    />
                                </Col>
                                <Col xs={24} md={12}>
                                    <Input
                                        placeholder="Valor (ex.: preto)"
                                        value={mf.value}
                                        onChange={(e) =>
                                            updateMetafield(mf.id, 'value', e.target.value)
                                        }
                                    />
                                </Col>
                                <Col
                                    xs={24}
                                    md={2}
                                    style={{ textAlign: 'right', marginTop: 8 }}
                                >
                                    <Button danger onClick={() => removeMetafield(mf.id)} style={{ color: 'white', backgroundColor: 'red' }}>
                                        Remover
                                    </Button>
                                </Col>
                            </Row>
                        </Card>
                    ))}

                    <Button type="dashed" onClick={addMetafield} block>
                        + Adicionar MetaField
                    </Button>
                </Space>
            </Card>
        </div>
    );
};

export default Metafields;
